import { EntityType } from '@frontend/common';
import { ProductCategoryClient } from '@frontend/group/api';
import { IGroup } from '@frontend/group/types';
import { Group } from '@frontend/group/utils';
import { useLocale } from '@frontend/lang';
import { useBlobRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import ImagePlaceholder from '../../../../../assets/images/image-placeholder.png';
import { useAppSelector } from '../../../../redux/store';
import { LeafCategoryCardProps } from './leaf-category-card.component';

export const useLeafCategoryCard = (props: LeafCategoryCardProps) => {
    const { locale } = useLocale();
    const blobRepository = useBlobRepository();
    const navigationStore = useAppSelector((state) => state.navigation);
    const [category, setCategory] = useState<IGroup | undefined>(props.category);
    const [image, setImage] = useState<string | null>(null);

    useEffect(() => {
        if (!navigationStore.iot) return;
        if (props.category_id && !props.category) {
            ProductCategoryClient.fetchProductCategory(navigationStore.iot.account_id, props.category_id).then(setCategory);
        }
    }, [props.category_id, props.category, navigationStore.iot]);

    useEffect(() => {
        if (props.category) {
            setCategory(props.category);
        }
    }, [props.category]);

    useEffect(() => {
        if (!category) return;
        new Group(category).getBlobImage(blobRepository, EntityType.PRODUCT_CATEGORY).then((image) => {
            if (!image) setImage(null);
            else setImage(image);
        });
    }, [category, blobRepository]);

    return {
        category,
        image,
        placeholder: ImagePlaceholder,
        locale
    };
};
